import { render } from "./CardPrimary.vue?vue&type=template&id=801e5bc0"
import script from "./CardPrimary.vue?vue&type=script&lang=js"
export * from "./CardPrimary.vue?vue&type=script&lang=js"

import "./CardPrimary.vue?vue&type=style&index=0&id=801e5bc0&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__